import Vue from 'vue';
import Popup from "./popup";
var PopupObj = Vue.extend(Popup);
Popup.install = function (config) {
  var instance = new PopupObj({
    propsData: {
      config: config
    }
  }).$mount();
  document.body.appendChild(instance.$el);
  Vue.nextTick(function () {
    instance.baseConfig.visible = true;
  });
  return instance;
};
export default Popup;